import { Courses } from "../modules";

export const CoursesPage = () => {
  return <Courses />;
};
